export default {
  'meta': {
    'langName': 'HONGARIAN',
    'lang': 'Magyar'
  },
  'title': 'TERMÉKVISSZAHÍVÁS KOSÁRLABDAPALÁNK TARMAK B900 BOX NBA ',
  'description': 'Üdvözlünk!  \n\nKöszönjük, hogy a Tarmak B900 BOX NBA kosárlabdapalánkot választottad!\n\n                                                                                                                                                 Termékeink minősége és biztonságos használata iránti folyamatos elkötelezettségünkből adódóan a KIPSTA Kosárlabda csapatai egy kockázatra figyelmeztetnek: fennáll a veszélye annak, hogy függőleges oszlop eldőlhet, ha azt a fogantyú nélkül használják.\n\nKérjük, válaszolj az alábbi kérdésekre, hogy segíthessünk biztonságossá tenni a termékedet. \n\nElnézésedet kérjük az esetleges kellemetlenségekért, és köszönjük a bizalmadat.\n\nDECATHLON\n',
  'emailConfirmation': {
    'title': 'Először is, erősítsd meg az e-mail címedet és a lakóhelyed szerinti országot:'
  },
  'fields': {
    'country': 'Ország',
    'address': 'E-mail cím',
    'email': 'E-mail cím',
    'phonePrefix': 'Országhívószám',
    'phone': 'Telefonszám',
    'validations': {
      'phoneOrEmail': 'Kérjük, adj meg legalább egy e-mail címet VAGY telefonszámot.',
      'email': 'Kérjük, adj meg egy érvényes e-mail címet',
      'phone': 'Kérjük, adj meg egy érvényes telefonszámot'
    },
    'firstName': 'Vezetéknév',
    'lastName': 'Keresztnév',
    'deliveryAddress': 'A csomag szállítási címe',
    'additionalAddress': 'További címadatok',
    'city': 'Település',
    'zip': 'Irányítószám',
    'choose': 'Válassz',
    'required': 'Kötelező mező'
  },
  'ownerCheck': {
    'title': 'Megvan még a B900 BOX NBA kosárlabdapalánkod?'
  },
  'yes': 'IGEN',
  'no': 'NEM',
  'ownerChanged': {
    'title': 'Megvan a kosárlabdapalánk jelenlegi tulajdonosának elérhetősége?',
    'confirmation': 'Kedves Vásárlónk!\n\nKöszönjük, hogy részt veszel ebben a minőségellenőrzésben.\n\nElnézésedet kérjük az esetleges kellemetlenségekért, és köszönjük a bizalmadat.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Kérjük, oszd meg velünk, hogy a fogantyú típusa szerint hány kosárlabdapalánkkal rendelkezel',
    'descriptionRed': 'Kosárlabdapalánk levehető, piros fogantyúval',
    'descriptionBlack': 'Kosárlabdapalánk nem levehető, fekete fogantyúval',
    'quantity': 'Mennyiség',
    'notConcerned': 'Kedves Vásárlónk!\n\nKöszönjük, hogy részt veszel ebben a minőségellenőrzésben.\n\nBiztosíthatunk arról, hogy a Tarmak B900 BOX NBA kosárlabdapalánkodat nem érinti a visszahívás. Továbbra is gondtalanul használhatod.\n\nElnézésedet kérjük az esetleges kellemetlenségekért, és köszönjük bizalmadat.\n\nDECATHLON',
    'concernedProductQuantity': 'Nem megfelelő termék mennyisége:',
    'concernedProductLabel': 'Nem megfelelő termék: ',
    'confirmation': 'Köszönjük, hogy kitöltötted a kérdőívet! Kérésedet rögzítettük.\n\nA csomagod nyomonkövetési számát a lehető leghamarabb elküldjük neked.\n\nTovábbi szép napot!\n\nDECATHLON'
  },
  'repair': {
    'title': 'Önálló javítás',
    'description': '​Megállapítottuk, hogy fennáll a kockázata annak, hogy a TARMAK B900 BOX NBA kosárlabdapalánk (termékkód: 4239136) függőleges oszlopa eldőlhet, ha azt a fogantyú nélkül használják.  \nVálaszod alapján úgy tűnik, hogy a te kosárlabdapalánkod is érintett ebben a kockázatban.\n\nEzért kérjük, hogy azonnal hagyd abba a használatát. Felajánljuk segítségünket a fogantyú utólagos beállításához, hogy a terméket ismét biztonságosan használhasd.\n\nEhhez az egyszerű javításhoz nincs szükséged különösebb szakértelemre; mindent pontosan elmagyaráz az alábbi videó és útmutató:',
    'videoLink': 'Link a videóhoz',
    'docLink': 'Link az útmutatóhoz',
    'callToAction': 'Kattints ide az ingyenes javítókészlet igényléséhez',
    'warranty': 'A teljes folyamatra 5 év jótállás vonatkozik'
  },
  'repairRequest': {
    'title': 'Kérjük, add meg az alábbi információkat, hogy az ingyenes készletet a választott címedre tudjuk küldeni:'
  },
  'form': {
    'submit': 'Következő'
  },
  'status': 'Translation validated by COUNTRY'
} as const
